document.addEventListener('DOMContentLoaded', function () {
    toggleCheckoutModal();
});

function toggleCheckoutModal() {
    const trigger = jQuery('[data-modal-trigger]');
    const close = jQuery('[data-modal-close]');

    trigger.on('click', function (e) {
        e.preventDefault();
        const modal = jQuery(`#${this.dataset.modalTrigger}`);
        modal.toggleClass('active');
    });

    close.on('click', function () {
        const thisElement = jQuery(this);
        const modal = thisElement.parent('.modal');
        modal.toggleClass('active');
    });

    // Reset on click outside the menu
    window.addEventListener('click', function (e) {
        if (jQuery('.modal.active').length != 0) {
            const activeModale = jQuery(".modal.active");
            if (e.target.closest('.modal.active') == null && e.target.closest('[data-modal-trigger]') == null && e.target.closest('.btn-tertiary.trigger-product-detail-modal') == null) {
                activeModale.toggleClass('active');
            }
        }
    });
}